import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage, useIntl } from 'react-intl';

import { FilterInDropdown } from '@sorare/core/src/atoms/dropdowns/FilterInDropdown';
import { RadioGroup } from '@sorare/core/src/atoms/inputs/RadioGroup';
import { fantasy } from '@sorare/core/src/lib/glossary';

import { DivisionSelector_so5Leaderboard } from './__generated__/index.graphql';

type Props = {
  selectedSo5Leaderboard: Nullable<DivisionSelector_so5Leaderboard>;
  so5Leaderboards: DivisionSelector_so5Leaderboard[];
  onChange: (so5LeaderboardSlug: string) => void;
};

export const DivisionSelector = ({
  selectedSo5Leaderboard,
  so5Leaderboards,
  onChange,
}: Props) => {
  const { formatMessage } = useIntl();

  const options = so5Leaderboards.map(so5Leaderboard => ({
    label: formatMessage(fantasy.division, {
      division: so5Leaderboard.division,
    }),
    value: so5Leaderboard.slug,
  }));

  const actualSelectedLeaderboard =
    selectedSo5Leaderboard || so5Leaderboards[0];

  return (
    <FilterInDropdown
      buttonLabel={
        <FormattedMessage
          {...fantasy.division}
          values={{ division: actualSelectedLeaderboard.division }}
        />
      }
    >
      {({ closeDropdown }) => (
        <RadioGroup
          options={options}
          initiallySelectedValue={actualSelectedLeaderboard.slug}
          name="division-selector"
          onChange={value => {
            const selected = so5Leaderboards.find(
              so5Leaderboard => so5Leaderboard.slug === value
            );
            if (selected) {
              onChange(selected.slug);
              closeDropdown();
            }
          }}
        />
      )}
    </FilterInDropdown>
  );
};

DivisionSelector.fragments = {
  so5Leaderboard: gql`
    fragment DivisionSelector_so5Leaderboard on So5Leaderboard {
      slug
      division
    }
  ` as TypedDocumentNode<DivisionSelector_so5Leaderboard>,
};
